import React, { useEffect, useLayoutEffect, useState } from "react";
import { Card, Row, Col, Typography, Button, Divider, Space, Image, Alert } from "antd";
import { BankOutlined } from "@ant-design/icons";
import storeLogo from "../../../assets/img/eqari-logo.svg"
import { useParams } from "react-router-dom";
import { currencyFormat } from "../../../utils/media";
import { getPaymentLink, getPaymentLinkNow } from "./ducks/service";
import LoaderTsx from "../Loader.tsx";

import NotFound from "../NotFound";
const { Title, Text } = Typography;

export default () => {

  const { leaseId, userId } = useParams();
  const [data, setData]: any = useState([]);
  const [dataNotFound, setDataNotFound] = useState(null);
  const[paymetReason,setPaymentReason] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getCCAvenuPaymentLink = async () => {
    setIsLoading(true);
    try {
      let result = await getPaymentLink({ leaseId, userId });
      setData(result?.data?.result);
      setIsLoading(false);
    } catch (error) {
      setDataNotFound(error?.response?.status)
      setIsLoading(false);
    }
  }

  useLayoutEffect(() => {
    getCCAvenuPaymentLink();
  }, []);

  const handlePayNowClick = async () => {
    setIsLoading(true);
    try {

      let result = await getPaymentLinkNow({ leaseId, userId });
      setIsLoading(false);
      if(result?.data?.result?.paymentLink === ""){
        setPaymentReason(result?.data?.result?.reason);
      }else{
        (result?.data?.result?.paymentLink && result?.data?.result?.paymentLink != "") &&
        window.open(result?.data?.result?.paymentLink, "_blank");
      }
     
    } catch (error) {
      setDataNotFound(error?.response?.status)
      setIsLoading(false);
    }
  };

  // helping function for date formate
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const year = String(date.getFullYear()).slice(-2); // get last 2 digits
    return `${day}/${month}/${year}`;
  };


  return (

    <>
      <div style={{ padding: 24 }}>

        {
          (dataNotFound === 404) ?

            <NotFound fourZerofour={true} />
            :

            <Card bordered={false} style={{ maxWidth: 1200, margin: "0 auto" }}>
              <Row justify="space-between" align="middle">
                <Col xs={24} sm={12} style={{ marginBottom: 12 }}>
                  <Image
                    src={storeLogo}
                    preview={false}
                    width={150}
                    alt="EQARCOM logo"
                    style={{ marginLeft: "-5px" }}
                  />
                </Col>

                {data?.propertyDetails?.propertyName && <Col xs={24} sm={12} style={{ textAlign: "right" }}>
                  <Title level={3} style={{ color: "black", marginBottom: 0 }}>{`${data?.propertyDetails?.propertyName} | ${data?.propertyDetails?.unitCode}`}</Title>
                </Col>}
              </Row>
              <Divider />
              {
                isLoading ?
                  <LoaderTsx />
                  :

                  <>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={12}>
                        <Card title="Tenant Information" style={{ maxWidth: 500, margin: "0 auto" }}>
                          <Text strong style={{ fontWeight: 700 }}>Name:</Text> {data?.tenantDetails?.tenantNameEN} <br />
                          <Text strong style={{ fontWeight: 700 }}>Phone:</Text> {data?.tenantDetails?.mobileNumber} <br />
                          <Text strong style={{ fontWeight: 700 }}>Email:</Text> {data?.tenantDetails?.email}
                        </Card>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Card title="Lease Information" style={{ maxWidth: 500, margin: "0 auto" }}>
                          <Text strong style={{ fontWeight: 700 }}>Lease Term:</Text>  {formatDate(data?.leaseTerms?.leaseStartDate)} - {formatDate(data?.leaseTerms?.leaseEndDate)} <br />
                          <Text strong style={{ fontWeight: 700 }}>Rent:</Text> {currencyFormat(data?.bookingTerms?.annualBaseRent)} <br />
                          <Text strong style={{ fontWeight: 700 }}>Move-in Date:</Text>{formatDate(data?.leaseTerms?.moveInDate)} <br />
                          <Text strong style={{ fontWeight: 700 }}>Move-out Date:</Text>  {formatDate(data?.vacatingDate)} <br />
                          <Text strong style={{ fontWeight: 700 }}>Termination Type:</Text>  {data?.moveOutType?.toLocaleUpperCase()}
                        </Card>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                      <Col xs={24} sm={12}>
                        <Card title="Move-out Summary" style={{ maxWidth: 500, margin: "0 auto" }}>
                          <Text strong style={{ fontWeight: 700 }}>Security Deposit:</Text> {currencyFormat(data?.leaseTerms?.securityDeposit)}<br />
                          <Text strong style={{ fontWeight: 700 }}>Prepaid Rent:</Text> AED 0.00 <br />
                          {/* <Text strong style={{ fontWeight: 700 }}>Lease Term:</Text> 365 days <br /> */}
                          <Text strong style={{ fontWeight: 700 }}>Days Occupied:</Text> {data?.daysOccupied ? data?.daysOccupied : 0} days <br />
                          <Text strong style={{ fontWeight: 700 }}>Rent Per Day:</Text> {data?.rentPerDay ? currencyFormat(data?.rentPerDay) : "AED 0"}
                        </Card>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Card title="Move-out Charges" style={{ maxWidth: 500, margin: "0 auto" }}>
                          {/* <Text strong style={{ fontWeight: 700 }}>Rent Due:</Text> AED 4,000 <br /> */}
                          <Text strong style={{ fontWeight: 700 }}>Early Termination Fee:</Text> {data?.termination?.totalterminationPaneltyAmount ? currencyFormat(data?.termination?.totalterminationPaneltyAmount) : "AED 0"} <br />
                          <Text strong style={{ fontWeight: 700 }}>Overstay Fee:</Text> {data?.overstay?.totalOverStayPaneltyAmount ? currencyFormat(data?.overstay?.totalOverStayPaneltyAmount) : 'AED 0'} <br />
                          <Text strong style={{ fontWeight: 700 }}>Maintenance Fee:</Text>{(data?.settlementSummary?.maintenancefee && data?.settlementSummary?.maintenancefee > 0) ?
                            currencyFormat(data?.settlementSummary?.maintenancefee) : "AED 0"
                          }<br />
                          <Text strong style={{ fontWeight: 700 }}>Refurbishment Fee:</Text> {(data?.settlementSummary?.refurbismentfee && data?.settlementSummary?.refurbismentfee > 0) ?
                            currencyFormat(data?.settlementSummary?.refurbismentfee) : "AED 0"
                          } <br />
                          <Text strong style={{ fontWeight: 700 }}>Other / Admin Fee:</Text> {(data?.settlementSummary?.otheradminfee && data?.settlementSummary?.otheradminfee > 0) ?
                            currencyFormat(data?.settlementSummary?.otheradminfee) : "AED 0"
                          }
                        </Card>
                      </Col>
                    </Row>

                    <Card title="Total Settlement Charges" style={{ marginTop: 16, maxWidth: 1024, marginLeft: "auto", marginRight: "auto" }}>
                      <Text strong style={{ fontWeight: 700 }}>From Landlord to Tenant:</Text> AED 0.00 <br />
                      <Text strong style={{ fontWeight: 700 }}>From Tenant to Landlord:</Text> {(data?.totalAmount && data?.totalAmount > 0) ? currencyFormat(data?.totalAmount) : 'AED 0'}
                    </Card>

                    <Row justify="center" style={{ marginTop: 20 }}>
                      <Space>

                        {
                          ((data?.payNowButtonEnable === false && data?.reason !== "") || paymetReason) ?
                            <Alert message={paymetReason ? paymetReason : data?.reason} type="info" showIcon /> :

                       
                            <Button disabled={!data?.payNowButtonEnable}  onClick={() => handlePayNowClick()} className="ef-approve-btn" type="primary" icon={<BankOutlined />} size="large">
                              Pay Now
                            </Button>

                        }
                      </Space>
                    </Row>
                  </>
              }

            </Card>
        }
      </div>
    </>
  );
};




